<h1 mat-dialog-title>{{ 'Delete' | translate }}</h1>

<form class="ix-form-container" [formGroup]="form" (submit)="onSubmit()">
  <div
    mat-dialog-content
    class="device-delete-modal-content"
  >
    <p
      [innerHTML]="'Delete <b>{deviceType} {device}</b>' | translate: { device: device.id, deviceType: device.dtype }"
    ></p>

    <ng-container *ngIf="device.dtype === VmDeviceType.Disk">
      <ix-checkbox
        formControlName="zvol"
        [label]="'Delete zvol device' | translate"
      ></ix-checkbox>

      <ix-input
        *ngIf="form.value.zvol"
        formControlName="zvolConfirm"
        [label]="zvolConfirmLabelText"
      ></ix-input>
    </ng-container>

    <ix-checkbox
      *ngIf="device.dtype === VmDeviceType.Raw"
      formControlName="raw_file"
      [label]="'Delete raw file' | translate"
    ></ix-checkbox>

    <ix-checkbox
      formControlName="force"
      [label]="'Force Delete' | translate"
    ></ix-checkbox>
  </div>

  <div mat-dialog-actions class="device-delete-modal-actions">
    <button
      type="button"
      mat-button
      class="mat-mdc-button mat-button mat-accent action-btn"
      name="Cancel_button"
      ixTest="cancel"
      (click)="cancel()"
    >
      {{ 'Cancel' | translate }}
    </button>
    <button
      *ixRequiresRoles="requiredRoles"
      type="submit"
      mat-button
      class="mat-mdc-button mat-button mat-primary"
      name="Delete Device_button"
      ixTest="delete-device"
      [disabled]="form.invalid"
    >
      {{ 'Delete Device' | translate }}
    </button>
  </div>
</form>
